import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const HandIndicator = ({currentHand}) => { 
    return (
        <div className={currentHand ? "hand-indicator left" : "hand-indicator right"}>
        </div>);
}

const mapStateToProps = (state, props) => {
    let tidal = props.effect.getConnectedTidal(props.number - 1);
    
    return {
        currentHand: tidal && tidal.lastLeafStep && tidal.lastLeafStep.hand
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HandIndicator);
